module.exports = __webpack_public_path__ + "media/images/icons/caret-f8281c6794ac6d3ddfaebb6cbb2b7910.svg";